import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/Auth';
import { useRecoilValue } from 'recoil';
import { currentProjectState } from '../../recoil/project';

export default function PublicOutlet() {
    const { isLoggedIn } = useAuth();
    const currentProject = useRecoilValue(currentProjectState);

    // If user is logged in, redirect to their project or projects list
    if (isLoggedIn) {
        if (currentProject?.id) {
            return <Navigate to={`/projects/${currentProject.id}/environments`} replace />;
        }
        return <Navigate to="/projects" replace />;
    }

    return <Outlet />;
}
